<script lang="typescript">
    import LensDetail from "./LensDetail.svelte";
    import { variantImages } from "../appData.js";
</script>

<LensDetail title="Easy Clean Plus Blue" images={variantImages.easyCleanPlusBlue}>
    <div>
        <h2>Additional benefits:</h2>
        <ul>
            <li>
                <strong>Ultra scratch resistance: </strong>Offering our best protection from
                scratches
            </li>
            <li>
                <strong>Anti-Static technology: </strong>The lenses attract less dust, so keep
                cleaner for longer
            </li>
            <li>
                <strong>A ‘blue-violet’ filter: </strong>
                Main source of blue-violet light comes from sunlight. This coating filters blue-violet
                light, indoors and outdoors.
            </li>
        </ul>
    </div>
    <div>
        <h2>Who is it suitable for?</h2>
        <ul>
            <li>
                Someone who spends time indoors and outdoors, including driving and playing sport.
            </li>
        </ul>
    </div>
</LensDetail>
